<script context="module">
	import { z } from "zod";
	export const name = "Hero";
	export const CustomFields = z.object({
		show_standfirst: z.boolean().optional(),
	});
</script>

<script>
	import ImageView from "@reperio-news/core.components/ImageView.svelte";
	import { kicker as getKicker } from "../../includes/content.js";
	import Stamp from "./Stamp.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	$: content = data && data.content;
	$: cf = (data && data.custom_fields) || {};
	$: showStandfirst = cf.show_standfirst !== false;
	$: k = getKicker(content);
</script>

{#if content}
	<article class="af-hero af-item af-item--hero">
		<a class="af-hero__link" href={content.url}>
			<div class="af-hero__media">
				{#if content.poster}
					<!-- the page's LCP candidate: eager + high priority, one per page -->
					<ImageView
						src={content.poster}
						crop={content.poster.crop}
						alt={content.title}
						width={1200}
						height={675}
						widths={[1600, 1200, 800]}
						heights={[900, 675, 450]}
						fit="cover"
						loading="eager"
						fetchpriority="high"
					/>
				{/if}
			</div>
			<div class="af-hero__body">
				{#if k}<span class="af-kicker af-hero__kicker">{k.name}</span>{/if}
				<h2 class="af-hero__title">{content.title}</h2>
				{#if showStandfirst && content.summary}
					<p class="af-hero__standfirst">{content.summary}</p>
				{/if}
				<Stamp {content} />
			</div>
		</a>
	</article>
{/if}

<style lang="scss">
	@use "../../styles/mixins" as m;

	.af-hero {
		@include m.af-card;
		background: var(--af-ink);
	}

	.af-hero__link {
		position: relative;
		display: block;
		height: 100%;
		color: var(--af-on-image);
	}

	.af-hero__media {
		position: relative;
		aspect-ratio: 4 / 5;
		max-height: 34rem;
		background: #14161a;

		:global(picture),
		:global(img) {
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		/* theme-invariant overlay: the title always sits on ink */
		&::after {
			content: "";
			position: absolute;
			inset: 0;
			background: var(--af-overlay-hero);
		}
	}

	.af-hero__body {
		position: absolute;
		inset: auto 0 0 0;
		display: flex;
		flex-direction: column;
		gap: var(--af-space-2);
		padding: var(--af-space-6);
	}

	.af-hero__kicker {
		color: var(--af-on-image);
		opacity: 0.85;
	}

	.af-hero__title {
		font: 600 var(--af-text-h2) / var(--af-leading-tight) var(--af-font-serif-display);
		color: var(--af-on-image);
		text-wrap: balance;
		@include m.af-clamp(4);
	}

	.af-hero__standfirst {
		display: none;
		font-size: var(--af-text-standfirst);
		line-height: var(--af-leading-ui);
		color: var(--af-on-image);
		opacity: 0.85;
		max-width: 40rem;
		@include m.af-clamp(2);
	}

	.af-hero :global(.af-item__stamp) {
		color: var(--af-on-image);
		opacity: 0.7;
	}

	@media (min-width: 768px) {
		.af-hero__media {
			aspect-ratio: auto;
			max-height: none;
			min-height: var(--af-bento-hero-min);
			height: 100%;
		}

		.af-hero__title {
			font-size: var(--af-text-display);
		}

		.af-hero__body {
			padding: var(--af-space-8);
		}

		.af-hero__standfirst {
			display: -webkit-box;
		}
	}
</style>
